import React, { useState } from 'react';
import ConsultationSection from '../components/ConsultationSection';
import './QuranTranslationClasses.css';

const QuranTranslationClasses = () => {
  const [faqOpenStates, setFaqOpenStates] = useState({
    'trans-left-0': true
  });

  return (
    <div className="quran-translation-page">

      {/* Hero Section */}
      <section
        className="about-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Quran Translation Classes Online</h1>



          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">Home</a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Quran Translation Classes</span>
          </nav>
        </div>
      </section>

      {/* Course Intro Banner */}
      <section className="qtc-intro-banner">
        <div className="qtc-intro-banner__container">
          <h2 className="qtc-intro-banner__title">ONLINE QURAN TRANSLATION (TAFSEER) COURSE</h2>
          <p className="qtc-intro-banner__subtitle">
            This course is especially designed for students who want to learn to translate Quran so that they are able to understand the meaning of the verses of Quran.
          </p>
          <a href="/free-trial/" className="qtc-intro-banner__btn">START TODAY</a>
        </div>
      </section>

      {/* Course Features Section */}
      <section className="qtc-features">
        <div className="qtc-features__container">

          {/* Left: Feature List */}
          <div className="qtc-features__list">

            <div className="qtc-features__item">
              <div className="qtc-features__item-header">
                <span className="qtc-features__leaf">🌿</span>
                <h3 className="qtc-features__item-title">Arabic Words</h3>
              </div>
              <p className="qtc-features__item-desc">Students are taught the meaning of few Arabic words every day.</p>
            </div>
            <div className="qtc-features__item-divider"></div>

            <div className="qtc-features__item">
              <div className="qtc-features__item-header">
                <span className="qtc-features__leaf">🌿</span>
                <h3 className="qtc-features__item-title">Verses Word by Word</h3>
              </div>
              <p className="qtc-features__item-desc">The students are taught meaning of the verses word by word.</p>
            </div>
            <div className="qtc-features__item-divider"></div>

            <div className="qtc-features__item">
              <div className="qtc-features__item-header">
                <span className="qtc-features__leaf">🌿</span>
                <h3 className="qtc-features__item-title">Quran Translation with Tafseer</h3>
              </div>
              <p className="qtc-features__item-desc">After literal translation of the Verses, the students are explained the contextual meaning of the Words and Verses.</p>
            </div>

          </div>

          {/* Right: Image */}
          <div className="qtc-features__image-wrap">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/Alquran-2.jpg`}
              alt="Student holding the Holy Quran"
              className="qtc-features__image"
            />
          </div>

        </div>
      </section>

      {/* Consultation Section */}
      <ConsultationSection
        title="Let's Help You Understand the Quran Better"
        subtitle="Tell us about your learning goals and we'll match you with the right Quran Translation scholar. Fill out the form below — our team will reach out to schedule your 3-day free trial."
      />

    </div>
  );
};

export default QuranTranslationClasses;

